import ArbitrageOrderInquiry from './arbitrage-order-inquiry.vue'
export default ArbitrageOrderInquiry
